import React from 'react';
import styled from 'styled-components';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => {
    switch (props.justify) {
      case 'left': return 'flex-start';
      case 'right': return 'flex-end';
      case 'center': return 'center';
      default: return 'flex-start';
    }
  }};
`;

const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: ${props => {
    switch (props.size) {
      case 'small': return '40px';
      case 'medium': return '50px';
      case 'large': return '60px';
      case 'xlarge': return '70px';
      default: return props.width || '50px';
    }
  }};
  height: ${props => {
    switch (props.size) {
      case 'small': return '20px';
      case 'medium': return '24px';
      case 'large': return '30px';
      case 'xlarge': return '36px';
      default: return props.height || '24px';
    }
  }};
  cursor: pointer;
`;

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const ToggleSlider = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.checked ? '#7ae66a' : '#ccc'};
  transition: 0.4s;
  border-radius: ${props => {
    switch (props.size) {
      case 'small': return '20px';
      case 'medium': return '24px';
      case 'large': return '30px';
      case 'xlarge': return '36px';
      default: return props.borderRadius || '24px';
    }
  }};

  &:before {
    position: absolute;
    content: "";
    height: ${props => {
    switch (props.size) {
      case 'small': return '14px';
      case 'medium': return '18px';
      case 'large': return '24px';
      case 'xlarge': return '30px';
      default: return props.sliderHeight || '18px';
    }
  }};
    width: ${props => {
    switch (props.size) {
      case 'small': return '14px';
      case 'medium': return '18px';
      case 'large': return '24px';
      case 'xlarge': return '30px';
      default: return props.sliderWidth || '18px';
    }
  }};
    left: ${props => {
    switch (props.size) {
      case 'small': return '3px';
      case 'medium': return '3px';
      case 'large': return '3px';
      case 'xlarge': return '3px';
      default: return props.sliderLeft || '3px';
    }
  }};
    bottom: ${props => {
    switch (props.size) {
      case 'small': return '3px';
      case 'medium': return '3px';
      case 'large': return '3px';
      case 'xlarge': return '3px';
      default: return props.sliderBottom || '3px';
    }
  }};
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
    transform: ${props => {
    if (props.checked) {
      switch (props.size) {
        case 'small': return 'translateX(20px)';
        case 'medium': return 'translateX(26px)';
        case 'large': return 'translateX(30px)';
        case 'xlarge': return 'translateX(34px)';
        default: return props.translateX || 'translateX(26px)';
      }
    }
    return 'translateX(0)';
  }};
  }

  &:focus {
    box-shadow: 0 0 1px #7ae66a;
  }
`;

const Toggle = ({
  checked,
  onChange,
  disabled = false,
  justify = 'center',
  size = 'medium', // 'small', 'medium', 'large', 'xlarge'
  width,
  height,
  borderRadius,
  sliderHeight,
  sliderWidth,
  sliderLeft,
  sliderBottom,
  translateX
}) => {
  return (
    <ToggleContainer justify={justify}>
      <ToggleSwitch
        size={size}
        width={width}
        height={height}
      >
        <ToggleInput
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <ToggleSlider
          checked={checked}
          size={size}
          borderRadius={borderRadius}
          sliderHeight={sliderHeight}
          sliderWidth={sliderWidth}
          sliderLeft={sliderLeft}
          sliderBottom={sliderBottom}
          translateX={translateX}
        />
      </ToggleSwitch>
    </ToggleContainer>
  );
};

export default Toggle;